import Vue from 'vue';

export default Vue.component('edit-blog-list', {
  template: require('./template.html'),
  name: 'edit-blog-list',
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      display: {
        visible: 0,
        loadMoreText: '',
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.display.visible = this.droplet.visible;
      this.display.loadMoreText = this.droplet.loadMoreText;
    },
    debounceSet(params) {
      this._debounce(() => {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: params.key,
          val: this.display[params.key],
        });
        this.bouncePlugin();
      }, 300);
    },
    async bouncePlugin() {
      await this.$vnode.context.destroyPlugin();
      this.$vnode.context.initPlugin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/blog-list/components/_edit-options/index.js